(function () {
  'use strict';

  const KEY = 'spark_storefront_transition';
  const DURATION = 850;

  // Identify SpecialWorx pages.
  function isSpecialWorx(url) {
    const path = url.pathname.toLowerCase();
    const host = url.hostname.toLowerCase();

    if (host === 'specialworx.sparkmoto.net') {
      return true;
    }

    if (
      path === '/pages/specialworx' ||
      path.startsWith('/pages/specialworx-') ||
      path.startsWith('/pages/specialworx/')
    ) {
      return true;
    }

    if (
      path.startsWith('/products/') &&
      url.searchParams.get('view') === 'specialworx'
    ) {
      return true;
    }

    return false;
  }

  function currentStorefront() {
    return isSpecialWorx(new URL(window.location.href))
      ? 'specialworx'
      : 'sparkmoto';
  }

  // Create the loading screen.
  function createScreen(destination) {
    const screen = document.createElement('div');

    screen.id = 'spark-storefront-transition';

    screen.className =
      destination === 'specialworx'
        ? 'spark-transition-sw'
        : 'spark-transition-sm';

    const title = document.createElement('div');
    title.className = 'spark-transition-title';

    title.textContent =
      destination === 'specialworx'
        ? 'SPECIALWORX'
        : 'SPARKMOTO';

    const slogan = document.createElement('div');
    slogan.className = 'spark-transition-slogan';
    slogan.textContent = 'BUILT DIFFERENT, NO LIMITS';

    const bar = document.createElement('div');
    bar.className = 'spark-transition-bar';

    const fill = document.createElement('div');
    fill.className = 'spark-transition-fill';

    bar.appendChild(fill);

    const code = document.createElement('div');
    code.className = 'spark-transition-code';

    code.textContent =
      destination === 'specialworx'
        ? 'SW-008'
        : 'SM-008';

    screen.append(title, slogan, bar, code);

    return screen;
  }

  // Display the loading screen.
  function showScreen(destination) {
    const existing = document.getElementById(
      'spark-storefront-transition'
    );

    if (existing) return existing;

    const screen = createScreen(destination);

    document.body.appendChild(screen);

    requestAnimationFrame(function () {
      screen.classList.add('is-visible');
    });

    return screen;
  }

  // Remove the loading screen.
  function removeScreen(screen) {
    if (!screen) return;

    screen.classList.add('is-leaving');

    setTimeout(function () {
      screen.remove();
    }, 350);
  }

  // Show a transition only after switching storefronts.
  function showArrivalScreen() {
    const pending = sessionStorage.getItem(KEY);

    sessionStorage.removeItem(KEY);

    if (!pending) return;

    let transition;

    try {
      transition = JSON.parse(pending);
    } catch (error) {
      return;
    }

    if (
      transition.destination !== currentStorefront() ||
      Date.now() - transition.time > 15000
    ) {
      return;
    }

    const screen = showScreen(transition.destination);

    setTimeout(function () {
      removeScreen(screen);
    }, DURATION);
  }

  // Detect storefront-switching links.
  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0) {
      return;
    }

    if (
      event.ctrlKey ||
      event.metaKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    const link = event.target.closest('a[href]');

    if (!link) return;

    if (link.hasAttribute('download')) return;

    if (link.target && link.target !== '_self') return;

    let destinationURL;

    try {
      destinationURL = new URL(link.href, location.href);
    } catch (error) {
      return;
    }

    if (
      destinationURL.protocol !== 'https:' &&
      destinationURL.protocol !== 'http:'
    ) {
      return;
    }

    const from = currentStorefront();

    const to = isSpecialWorx(destinationURL)
      ? 'specialworx'
      : 'sparkmoto';

    // Don't show screens within the same storefront.
    if (from === to) return;

    // Handle the SpecialWorx redirect subdomain.
    if (
      to === 'specialworx' &&
      destinationURL.hostname.toLowerCase() ===
        'specialworx.sparkmoto.net'
    ) {
      event.preventDefault();

      sessionStorage.setItem(
        KEY,
        JSON.stringify({
          destination: 'specialworx',
          time: Date.now()
        })
      );

      window.location.href = '/pages/specialworx';
      return;
    }

    // Only track normal same-origin navigation.
    if (destinationURL.origin !== location.origin) {
      return;
    }

    sessionStorage.setItem(
      KEY,
      JSON.stringify({
        destination: to,
        time: Date.now()
      })
    );
  });

  // Initialize after the page is ready.
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      showArrivalScreen
    );
  } else {
    showArrivalScreen();
  }

  // Clear old transitions when restoring cached pages.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      sessionStorage.removeItem(KEY);

      const screen = document.getElementById(
        'spark-storefront-transition'
      );

      if (screen) screen.remove();
    }
  });

})();